import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ChevronRight } from 'lucide-react';

interface CustomSelectProps {
  label?: string;
  value: string;
  options: { value: string; label: string }[];
  onChange: (val: string) => void;
}

export const CustomSelect = ({ label, value, options, onChange }: CustomSelectProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedLabel = options.find(o => o.value === value)?.label || 'Select...';

  return (
      <div className="relative">
          {label && <label className="block text-xs font-bold uppercase tracking-wider mb-3" style={{ color: '#666666' }}>{label}</label>}
          <button
              type="button"
              onClick={() => setIsOpen(!isOpen)}
              onBlur={() => setTimeout(() => setIsOpen(false), 200)}
              className="w-full px-4 py-3 bg-[#FAFAFA] border rounded-xl text-sm font-medium flex items-center justify-between transition-colors focus:ring-2 focus:ring-black/5 outline-none"
              style={{
                borderColor: 'rgba(26, 26, 26, 0.12)',
                color: '#1A1A1A'
              }}
          >
              <span className={!value ? "text-gray-400" : ""}>{selectedLabel}</span>
              <ChevronRight className={`w-4 h-4 text-neutral-400 transition-transform duration-200 ${isOpen ? 'rotate-90' : ''}`} />
          </button>
          <AnimatePresence>
              {isOpen && (
                  <motion.div
                      initial={{ opacity: 0, y: 5 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 5 }}
                      transition={{ duration: 0.15 }}
                      className="absolute top-full left-0 right-0 mt-1.5 bg-white border border-neutral-200 rounded-xl shadow-lg overflow-hidden z-50 p-1"
                  >
                      {options.map((opt) => (
                          <button
                              type="button"
                              key={opt.value}
                              onClick={() => {
                                  onChange(opt.value);
                                  setIsOpen(false);
                              }}
                              className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors flex items-center justify-between group ${
                                  value === opt.value ? 'bg-neutral-50 font-medium text-neutral-900' : 'text-neutral-600 hover:bg-neutral-50'
                              }`}
                          >
                              {opt.label}
                              {value === opt.value && <Check className="w-3.5 h-3.5 text-neutral-900" />}
                          </button>
                      ))}
                  </motion.div>
              )}
          </AnimatePresence>
      </div>
  );
};
